import { Cake, Droplet, Droplets, FlaskConical, Heart, Leaf, Pipette, Sparkles, SprayCan, Wind } from "lucide-react";
import type { Category, Feature } from "../types/product";

// Dati commerciali: modifica qui nome, prezzo, valutazione e link di pagamento.
export const product = {
  name: "Belnestore Sostenibile",
  recipes: "600+",
  bonusCount: 5,
  price: "37,00 €",
  rating: "4,9/5",
  reviewsCount: "1703 recensioni",
  checkoutUrl: "https://belnestoresostenibile.impultienda.ar/checkout"
};

// Sostituisci con le immagini reali del tuo materiale (URL completi).
export const images = {
  heroBundle: "https://cdn.magicpatterns.com/patterns/generated-images/1af701b5-47ac-4c79-ab83-e7316f28ba73.jpg",
  recipePage: "https://cdn.magicpatterns.com/patterns/generated-images/b14d7807-5245-4930-bfcf-c4e3787370c1.jpg",
  butters: "https://cdn.magicpatterns.com/patterns/generated-images/aee68963-84bc-4a45-a27f-e5c1ab36a6fd.jpg",
  soaps: "https://cdn.magicpatterns.com/patterns/generated-images/5f6f9917-7462-4590-9c84-22208d30dccd.jpg",
  lips: "https://cdn.magicpatterns.com/patterns/generated-images/3f7b3386-d303-4574-bca9-ea63822bd3bc.jpg"
};
export const galleryImages = [{
  src: images.heroBundle,
  alt: "Il pacchetto completo di ricette e bonus"
}, {
  src: images.butters,
  alt: "Burri, creme e sieri fatti in casa"
}, {
  src: images.soaps,
  alt: "Saponi, scrub e balsami fatti in casa"
}, {
  src: images.lips,
  alt: "Labbra, brume e deodoranti fatti in casa"
}, {
  src: images.recipePage,
  alt: "Esempio di pagina ricetta"
}];

// Ordine: prima colonna (5) poi seconda colonna (5).
export const categories: Category[] = [
  { count: 75, label: "Sapone montato", icon: Droplets },
  { count: 95, label: "Labbra (oli e balsami)", icon: Heart },
  { count: 95, label: "Burro corpo", icon: Cake },
  { count: 65, label: "Oli corpo e viso", icon: Droplet },
  { count: 50, label: "Scrub e peeling", icon: Sparkles },
  { count: 65, label: "Brume e tonici", icon: SprayCan },
  { count: 50, label: "Lozioni e creme", icon: FlaskConical },
  { count: 27, label: "Deodoranti naturali", icon: Wind },
  { count: 50, label: "Sieri viso", icon: Pipette },
  { count: 30, label: "Balsami alle erbe", icon: Leaf }
];

export const marqueeItems = [
  "600+ ricette DIY",
  "5 bonus gratuiti inclusi",
  "Per principianti, passo passo",
  "Grammi esatti, non \u201cq.b.\u201d",
  "Download digitale immediato"
];

export const heroFeatures: Feature[] = [{
  title: "600+ ricette in 10 collezioni",
  body: "Sapone montato, burro corpo, scrub e peeling, lozioni e creme, oli per corpo e viso, deodoranti, balsami alle erbe, labbra, sieri viso e brume. Organizzate per categoria, così sai sempre dove cercare."
}, {
  title: "Grammi esatti, niente a occhio",
  body: "Ogni ricetta ti dà pesi e percentuali, a cosa serve davvero ogni ingrediente, le temperature di lavorazione, il pH e il conservante giusto. Niente è lasciato al caso."
}, {
  title: "Una foto per ogni ricetta",
  body: "Ogni ricetta ha la foto del prodotto finito: sai esattamente cosa stai preparando e come deve venire, prima ancora di iniziare."
}, {
  title: "Sistema passo passo, anche se parti da zero",
  body: "Ti servono una bilancia digitale, una ciotola resistente al calore e dei vasetti puliti. Stasera puoi iniziare con burri e balsami: niente acqua, niente conservante, nessun pH da misurare."
}, {
  title: "Download immediato",
  body: "6 PDF di ricette e 5 guide bonus nella tua email appena paghi. Leggibili su telefono, tablet e computer, tue per sempre."
}];

export const comparisonRows = [{
  bought: "Un'etichetta che non riesci a leggere",
  made: "Ingredienti scelti da te"
}, {
  bought: "Il prezzo di un solo vasetto",
  made: "Uno scaffale intero"
}, {
  bought: "Finisce e lo ricompri",
  made: "Un altro lotto in quindici minuti"
}, {
  bought: "Lo stesso vasetto di tutti",
  made: "Un vasetto solo tuo"
}];
